import Utilities from "./utilities";
import Stop from "./stop";
import Route from "./route";

const $agencies = document.getElementById( 'tab-bus_routes' ).querySelector( '.tm__expandable-list' ),
	fetchInProgress = {};

const Agency = {
	openPanelAgencyDetail: ( tm, agencyId ) => {
		Route.updateVisibleRoute( tm, null );
		Stop.updateVisibleStop( tm, null );
		Stop.revertStopStyling( tm );
		Stop.closeStopInfowindow();

		Agency.updateVisibleAgency( tm, agencyId );
		Agency.preloadAgencyStops( tm );
		Route.updateRouteColors( tm );
		Agency.showVisibleAgency( tm );
	},

	updateVisibleAgency: ( tm, agencyId ) => {
		agencyId = agencyId ? parseInt( agencyId, 10 ) : null;
		tm.visible.agencyId = agencyId;
		const $btn = agencyId ? $agencies.querySelector( '[data-open-pane="agency|' + agencyId + '"]' ) : null;
		tm.visible.agencyName = $btn ? $btn.innerText : null;
	},

	showVisibleAgency: ( tm ) => {
		Stop.hideVisibleStops( tm );

		let bounds = new google.maps.LatLngBounds();

		tm.map.data.forEach( ( feature ) => {
			let agency = feature.getProperty( 'agency_id' );
			if ( !tm.visible.agencyId || tm.visible.agencyId === agency ) {
				// show feature and include it in the zoom bounds
				tm.map.data.overrideStyle( feature, {visible: true} );
				bounds.union( feature.getProperty( 'bounds' ) );
			} else {
				// hide feature and don't use it in the bounds
				tm.map.data.overrideStyle( feature, {visible: false} );
			}
		} );
		Utilities.zoomToBounds( tm, bounds );
	},

	preloadAgencyStops: ( tm ) => {
		return new Promise( ( resolve, reject ) => {
			if ( !tm.visible.agencyId ) {
				console.warn( "preloadAgencyStops no visible agency" );
				resolve();
				return;
			}

			if ( fetchInProgress[tm.visible.agencyId] ) {
				return new Promise( resolve2 => {
					const checkInterval = setInterval( () => {
						if ( !fetchInProgress[tm.visible.agencyId] ) {
							clearInterval( checkInterval );
							resolve2();
							resolve();
						}
					}, 100 );
				} );
			}

			if ( Object.keys( tm.stopLayers ).length && tm.stopLayers.hasOwnProperty( tm.visible.agencyId ) ) {
				// don't add the same agency layer twice
				resolve();
				return;
			}

			fetchInProgress[tm.visible.agencyId] = true;

			let url = tmVars.gtfsDir + 'geojson/stops_' + tm.visible.agencyId + '.geojson';
			Utilities.cachedFetch( url ).then( ( response ) => {
				return response.ok ? response.json() : Promise.reject( response );
			} ).then( ( data ) => {
				tm.stopLayers[tm.visible.agencyId] = new google.maps.Data();
				tm.stopLayers[tm.visible.agencyId].addGeoJson( data );

				// change stop style when you hover over it
				tm.stopLayers[tm.visible.agencyId].addListener( 'mouseover', ( e ) => Stop.stopHoveredInMap( e, tm, true ) );
				tm.stopLayers[tm.visible.agencyId].addListener( 'mouseout', ( e ) => Stop.stopHoveredInMap( e, tm, false ) );

				// open stop when you click on it
				tm.stopLayers[tm.visible.agencyId].addListener( 'click', ( e ) => {
					let stopId = parseInt( e.feature.getProperty( 'stop' ), 10 );
					if ( stopId ) {
						let $button = tm.$sidebar.querySelector( '[data-open-pane="stop|' + stopId + '"]' );
						if ( $button ) $button.click();
					}
				} );

				fetchInProgress[tm.visible.agencyId] = false;
				resolve();
			} ).catch( ( err ) => {
				console.error( 'Error:', err );
				reject();
			} );
		} );
	}
}

export default Agency;
